module.exports = __webpack_public_path__ + "img/Weapon_229.5f4a4e45.png";